export enum StatusMensagemIAEnum {
    MensagemUsuario = 1,
    MensagemIA = 2,
    Arquivo = 3,
    ErroApi = 4,
    ErroIntegracao = 5
}